
import { defineComponent } from 'vue';

import ModContentSplash from './mod-content-splash.vue';
import ModContentTimeline from './mod-content-timeline.vue';

import { modOverviewComposition } from '../services';

export default defineComponent({
	components: {
		ModContentSplash,
		ModContentTimeline
	},
	setup() {
		return { ...modOverviewComposition() }
	},
})
